<p>inventory-manager works!</p>
